import { ComputeFunctionType } from 'features/libra/stepComponents/conditionalForm/computed/computeFunctionTypes'
import { z } from 'zod'

export const WeightedParameterSchema = z.object({
  field: z.string(),
  weight: z.number(),
  inverted: z.boolean().optional(),
  defaultValue: z.union([z.string(), z.number(), z.boolean()]).optional(),
})

export type WeightedParameter = z.infer<typeof WeightedParameterSchema>

export const TriStateParameterSchema = z.object({
  field: z.string(),
  type: z.literal('tri-state'),
  defaultValue: z.enum(['low', 'med', 'high']).optional(),
})

export type TriStateParameter = z.infer<typeof TriStateParameterSchema>

export const FunctionSpecSchema = z.object({
  threshold: z.number().optional(),
  parameters: z
    .array(z.union([WeightedParameterSchema, TriStateParameterSchema]))
    .default([]),
})

export type FunctionSpec = z.infer<typeof FunctionSpecSchema>

export const ComputedSectionSchema = z.object({
  id: z.string(),
  type: z.literal('computed'),
  title: z.string().optional(),
  fieldId: z.string().optional(),
  function: z.nativeEnum(ComputeFunctionType),
  allowOverride: z.boolean().optional(),
  overrideField: z.string().optional(),
  overrideJustificationField: z.string().optional(),
  displayFields: z.array(z.string()).default([]),
  functionSpec: FunctionSpecSchema,
})

export type ComputedSection = z.infer<typeof ComputedSectionSchema>

/**
 * Gets the field ID where computed result should be stored
 */
export function getComputedFieldId(section: ComputedSection): string {
  return section.fieldId || section.id
}

export function isComputedSection(
  section: unknown
): section is ComputedSection {
  return (
    typeof section === 'object' &&
    section !== null &&
    'type' in section &&
    section.type === 'computed'
  )
}
